<script lang="ts">
  import * as Dialog from "$lib/components/ui/dialog/index.js";
  import { stateStore } from "$lib/stores/state.svelte";
  import Button from "./ui/button/button.svelte";

  function closeDialog() {
    stateStore.appInstallDialog = false;
  }
</script>

<Dialog.Root bind:open={stateStore.appInstallDialog}>
  <Dialog.Content
    class="border-2 border-black rounded-sm shadow-[3px_3px_0px_0px] shadow-foreground"
  >
    <Dialog.Header>
      <Dialog.Title class="text-center font-display font-light text-4xl">
        {stateStore.appInstallTitle}
      </Dialog.Title>
      <img alt="beeco-logo" class="mx-auto h-40" src="/assets/beeco-bee.svg" />
      <Dialog.Description class="text-start font-sans">
        {@html stateStore.appInstallDesc}
      </Dialog.Description>
    </Dialog.Header>
    <Button
      target="_blank"
      onclick={closeDialog}
      href="https://www.beeco.hu/hu/letoltes"
      class="w-48 mx-auto bg-primary hover:bg-primary/80 rounded-xs"
    >
      Letöltöm!
    </Button>
  </Dialog.Content>
</Dialog.Root>
